/**
 * リリースノート英語版（DF Viewer・英語版）
 * @returns JSX.Element
 */
export const ReleaseNotesDfViewerEn = () => {
    return (
        <div>
            {/* v1.4.1 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF Viewer v1.4.1</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2026-05-12</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Viewer v1.4.1 has been released.</p>
                    <br />
                    <p>Improved Functions</p>
                    <p>・Improved support for Windows security features.</p>
                    <br />
                </div>
            </div>

            {/* v1.4.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF Viewer v1.4.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2026-02-25</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Viewer v1.4.0 has been released.</p>
                    <br />
                    <p>New Features</p>
                    <p>・Added tree species color settings.</p>
                    <p>・Added new polygon creation function.</p>
                    <p>・Added tree crown → treetop conversion.</p>
                    <br />
                    <p>Function Improvements</p>
                    <p>・Improved behavior and rendering speed when loading GeoTIFF files.</p>
                    <p>・Support for drawing lines, multilines, and multipoints.</p>
                    <p>・Added proxy support and optimization for base map display.</p>
                    <br />
                </div>
            </div>

            {/* v1.3.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF Viewer v1.3.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-08-05</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Viewer v1.3.0 has been released.</p>
                    <br />
                    <p>New Features</p>
                    <p>・Pan/Zoom to feature from table.</p>
                    <p>・Distance and area calculation.</p>
                    <br />
                    <p>Function Improvements</p>
                    <p>・Improved GeoTIFF reading performance.</p>
                    <br />
                    <p>Bug Fixes</p>
                    <p>・Fixed an issue where learning data could not be loaded when loading a project.</p>
                    <br />
                </div>
            </div>

            {/* v1.2.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF Viewer v1.2.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2024-09-02</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Viewer v1.2.0 has been released.</p>
                    <br />
                    <p>New Features</p>
                    <p>・Supports importing GeoJSON files.</p>
                    <p>・Supports display of donut-shaped polygons and multi-polygons.</p>
                    <p>・Supports multiple file import.</p>
                    <p>・Check polygon information with the Information button.</p>
                    <p>・Supports project dounload.</p>
                    <br />
                    <p>Function Improvements</p>
                    <p>・Improved performance of polygon display.</p>
                    <p>・Fix basemap display.</p>
                    <p>・Improved loading GeoTIFF files with overview.</p>
                    <p>・Improved selection statistics calculation.</p>
                    <br />
                </div>
            </div>

            {/* v1.1.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF Viewer v1.1.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2024-03-29</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Viewer v1.1.0 has been released.</p>
                    <br />
                    <p>Function Improvements</p>
                    <p>・The drawing function has been updated.</p>
                    <br />
                </div>
            </div>

            {/* v1.0.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF Viewer v1.0.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2022-08-01</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>Released DF Viewer v1.0.0.</p>
                    <br />
                </div>
            </div>
        </div>
    );
};

export default ReleaseNotesDfViewerEn;
